import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from "@angular/core";
import { AuthService as Auth0SDKService } from "@auth0/auth0-angular";
import { SubSink } from "subsink";
import { SessionService } from "../../core/storage/session.service";
import { AuthService } from "../auth.service";

@Component({
  selector: "app-auth0-login",
  templateUrl: "./auth0-login.component.html",
  styleUrls: ["./auth0-login.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Auth0LoginComponent implements OnInit, OnDestroy  {
  auth0Error: string | null = null;
  private subs = new SubSink();


  constructor(
    private readonly auth0: Auth0SDKService,
    private readonly session: SessionService,
    private readonly authService: AuthService
  ) {
  }

  ngOnInit(): void {
    this.authService.clearStorage();

    this.subs.sink = this.auth0.error$.subscribe(err => {
      this.auth0Error = err?.message || null;
    });

  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  loginWithAuth0(event: Event): void {
    event.preventDefault();

    this.session.put("auth_type", "auth0");

    this.auth0.loginWithRedirect({
      appState: {
        target: "login/select-user",
      },
    });
  }

}
